import { render } from "./AddTransfertPointVentePage.vue?vue&type=template&id=33b24eba&ts=true"
import script from "./AddTransfertPointVentePage.vue?vue&type=script&lang=ts"
export * from "./AddTransfertPointVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__